import { Box, Typography } from '@mui/material';

function MediaItem({ item }) {
  const caption = item.caption ? (
    <Typography
      sx={{
        color: 'text.secondary',
        fontSize: '0.78rem',
        mt: 0.75,
        textAlign: 'center',
        fontStyle: 'italic',
      }}
    >
      {item.caption}
    </Typography>
  ) : null;

  if (item.type === 'video') {
    return (
      <Box sx={{ width: '100%' }}>
        <Box
          component="video"
          src={item.src}
          poster={item.poster}
          controls
          playsInline
          preload="metadata"
          aria-label={item.caption || 'Video del hito'}
          sx={{
            width: '100%',
            aspectRatio: '4/3',
            objectFit: 'cover',
            borderRadius: 2,
            backgroundColor: 'rgba(0,0,0,0.05)',
          }}
        />
        {caption}
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        component="img"
        src={item.src}
        alt={item.alt || item.caption || ''}
        loading="lazy"
        sx={{
          width: '100%',
          aspectRatio: '4/3',
          objectFit: 'cover',
          borderRadius: 2,
        }}
      />
      {caption}
    </Box>
  );
}

function MediaGallery({ media }) {
  if (!media?.length) return null;

  const single = media.length === 1;

  return (
    <Box
      sx={{
        mt: 2.5,
        display: { xs: 'flex', md: 'grid' },
        flexDirection: { xs: 'row', md: 'initial' },
        gridTemplateColumns: {
          md: single ? '1fr' : 'repeat(2, 1fr)',
        },
        gap: 2,
        // Mobile: horizontal scroll-snap carousel
        overflowX: { xs: 'auto', md: 'visible' },
        scrollSnapType: { xs: 'x mandatory', md: 'none' },
        scrollPadding: { xs: 16, md: 0 },
        px: { xs: 0.5, md: 0 },
        pb: { xs: 1, md: 0 },
        '&::-webkit-scrollbar': { height: 6 },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(74, 106, 74, 0.2)',
          borderRadius: 3,
        },
      }}
    >
      {media.map((item, i) => (
        <Box
          key={i}
          sx={{
            flex: { xs: `0 0 ${single ? '100%' : '82%'}`, md: 'initial' },
            scrollSnapAlign: { xs: 'start', md: 'none' },
          }}
        >
          <MediaItem item={item} />
        </Box>
      ))}
    </Box>
  );
}

export default MediaGallery;
